<template>
    <v-container>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear planificación de obra</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3" ref="form">
                        <v-col cols="12">
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        :to="'lista-plan-orden'"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-col>
                        <v-row>
                            <v-col cols="12" md="6">
                                <ordenesSelect
                                    v-model="plan.planificacion_orden_multiple"
                                    label="Obra"
                                    :extra="plan.orden_trabajo"
                                    :multiple="true"
                                >
                                </ordenesSelect>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    v-model="plan.id_estado"
                                    :items="estados"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Estados"
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="plan.fecha"
                                    label="Fecha de inicio"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="plan.fecha_fin"
                                    label="Fecha de fin"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="plan.horario"
                                    label="Horario"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="plan.planificacion_orden_equipo"
                                    :items="equipos"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Equipo"
                                    :rules="required_val"
                                    multiple
                                    chips
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field
                                    outlined
                                    v-model="plan.observacion"
                                    label="Observaciones"
                                    :rules="required_val"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-plan-orden">
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!plan.id"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    @click="createorden"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    @click="createorden"
                                    v-if="plan.id"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    @click="isDeletePlanDialogVisible = true"
                                    v-if="plan.id"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <!-- Dialog de eliminacion de plan -->
        <DeleteDialog
            v-model="isDeletePlanDialogVisible"
            @delete="deleteorden"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import { debounce } from "../../../helpers";
import ordenesSelect from "../../../components/general/ordenesSelect.vue";
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";

export default {
    components: { ordenesSelect, DeleteDialog },
    data() {
        return {
            isDeletePlanDialogVisible: false,
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            checked: false,
            productos: [],
            acciones: [],
            controles: [],
            equipos: [],
            ordenes: [],
            orden: {},
            plan: {
                id: null,
                id_orden: null,
                id_estado: null,
                fecha: "",
                fecha_fin: "",
                horario: "",
                observacion: "",
                planificacion_orden_equipo: [],
                orden_trabajo: null,
                planificacion_orden_multiple: [],
            },
            planificacion_orden_equipo: [],
            //Cruds de Selects dinamicos
            accion: {
                nombre: "",
            },
            control: {
                nombre: "",
            },
            estados: [],
        };
    },
    watch: {},
    created() {
        this.getEstados();
        //this.getOrdenes();
        this.getequipos();
        //this.getOrdenes();
        if (this.$route.query.id) {
            this.getorden(this.$route.query.id);
        }
    },
    methods: {
        async checkOrdenes() {
            if (this.plan.fecha != null && this.plan.id_equipo != null) {
                const resp = await axios.post(
                    `api/check-planes-orden`,
                    this.plan
                );
                if (resp.data.status == false) {
                    this.$custom_error(
                        resp.data?.message ?? "Error consultando la obra"
                    );
                    return false;
                }
                return true;
            }
            return false;
        },

        getequipos() {
            axios.get(`api/get-equipos`).then(
                (res) => {
                    this.equipos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando el equipo");
                }
            );
        },
        getEstados() {
            axios.get(`api/get-estados-plan-orden`).then(
                (res) => {
                    this.estados = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando el estado");
                }
            );
        },
        //funciones del Crud de Acciones

        getorden(id) {
            axios.get(`api/get-plan-orden/${id}`).then(
                (res) => {
                    const response = res.data;
                    this.plan = response;

                    if (response.planificacion_orden_multiple.length > 0) {
                        this.plan.orden_trabajo =
                            response.planificacion_orden_multiple;
                        this.plan.planificacion_orden_multiple =
                            response.planificacion_orden_multiple.map(
                                (item) => item.id_orden
                            );
                    }
                },
                (res) => {}
            );
        },
        deleteorden() {
            axios.get(`api/delete-orden/${this.plan.id}`).then(
                (res) => {
                    this.isDeletePlanDialogVisible = false;
                    this.$router.push("lista-plan-orden");
                },
                (res) => {}
            );
        },
        async createorden() {
            let checked = this.checked == true;
            if (!checked) {
                checked = await this.checkOrdenes();
                this.checked = true;
                console.log(this.checked);
            }
            if (!this.$refs.form.validate()) {
                return;
            }
            if (checked) {
                axios
                    .post("api/save-plan-orden", this.plan)
                    .then((res) => {
                        this.$router.push("lista-plan-orden");
                    })
                    .catch((error) => {
                        if (error.response.status == 400) {
                            this.$custom_error(error.response.data.message);
                        } else {
                            this.$custom_error(error.response.data.message);
                        }
                    });
            }
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        clientes() {
            /////console.log("siva");
            let clientes_temp = this.$store.getters.getclientes;

            return clientes_temp;
        },
        rol: function () {
            return localStorage.getItem("role");
        },
    },
};
</script>
